// src/utils/ticketUtils.js

// Evento local (mesma aba) usado para propagar mudanças de ticket entre as
// listas sem depender do socket. Necessário porque, ao voltar do segundo
// plano, a conexão socket pode estar morta sem o cliente saber ("zumbi"):
// o PUT funciona, mas os eventos delete/update do servidor nunca chegam.
export const TICKET_LOCAL_UPDATE_EVENT = "messageexpress:ticket-update";

export const emitLocalTicketUpdate = (ticket) => {
  window.dispatchEvent(
    new CustomEvent(TICKET_LOCAL_UPDATE_EVENT, { detail: ticket })
  );
};

// Mesma ideia, para exclusão: o backend só emite o evento de socket
// correspondente, então sem isso a lista/tela do ticket excluído ficava
// parada até um F5 caso o socket estivesse momentaneamente fora.
export const TICKET_LOCAL_DELETE_EVENT = "messageexpress:ticket-delete";

export const emitLocalTicketDelete = (ticketId) => {
  window.dispatchEvent(
    new CustomEvent(TICKET_LOCAL_DELETE_EVENT, { detail: ticketId })
  );
};

// Disparado após um envio de mensagem bem-sucedido (texto ou mídia). O envio
// para o WhatsApp e a persistência/emissão do evento de socket da mensagem
// são etapas assíncronas separadas no backend — o POST pode responder OK
// antes (ou mesmo sem) o evento de socket "create" chegar. MessagesList usa
// isso como rede de segurança, sincronizando a página mais recente pouco
// depois do envio, sem depender só do socket.
export const MESSAGE_LOCAL_SYNC_EVENT = "messageexpress:message-sync";

export const emitLocalMessageSync = (ticketId) => {
  window.dispatchEvent(
    new CustomEvent(MESSAGE_LOCAL_SYNC_EVENT, { detail: ticketId })
  );
};

export const canAccessTicket = (ticket, user, selectedQueueIds) => {
  const { profile, queues } = user;
  const ticketQueueId = ticket.queueId;

  // 1. Admin vê tudo
  if (profile === "admin") return true;

  // 2. Se não tem fila, só admin pode ver
  if (!ticketQueueId) return false;

  // 3. Verifica se o usuário tem acesso à fila
  return selectedQueueIds.includes(ticketQueueId);
};